import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import GlassPopup from '../common/interface/glassPopup';
import FieldInfo from '../common/inputs/fieldInfo';
import Spinner from '../common/interface/spinner';
import Select from '../common/inputs/select';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';

const EmailFinderByCalculationUnitPopup = props => {
  const {
    handleShowPopup,
    popupState,
    queryData,
    queryStatus,
    filterValues,
    onChangeFilter,
    calculationUnitsData,
    calculationUnitsFetchAction,
    calculationUnitsLoading,
    fullLoading    
  } = props;
  return (
    <GlassPopup
      handleShowPopup={handleShowPopup}
      popupState={popupState}
      className="form_popup entity_use_query_popup email_finder_by_calculation_popup"
      title={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="reportFileAdmin.email.searchEmailPopupTitle"/>)}
      {...props}
    > 
      {(InterfaceTooling.popupHasToRender(popupState)) && (
        <div>
          <FetchAutocompleteList        
            values={filterValues["calculationUnitsSelected"]}
            onChange={onChangeFilter}
            addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"periodAdmin.calculationUnitFilterFinderLabel"}))}
            options={InterfaceTooling.getSelectArrayFromArrayOfObjects(calculationUnitsData, "id", "name", false)}
            valueAccesor={"id"}
            labelAccesor={"name"}
            fetchListAction={calculationUnitsFetchAction}
            loadingFetch={calculationUnitsLoading}
            data-path="calculationUnitsSelected"
          />
          <div className="entity_use_query_popup_result_wrapper">
            <div className="entity_use_query_popup_result_title">
              {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="reportFileAdmin.email.searchEmailPopupResultsTitle"/>)}:
            </div>
            {queryStatus==200 && (
              <div className="entity_use_query_popup_result_data_wrapper">
                {filterValues.calculationUnitsSelected.map((elem_cunit, elem_cunit_index) => (
                  <div key={elem_cunit_index} className="entity_use_query_popup_result_data_block">
                    <label className="entity_use_query_popup_result_data_block_label">
                      {elem_cunit.name + ":"}
                    </label>
                    <div className="entity_use_query_popup_result_data_block_results">
                      {queryData.map((elem, elem_index) => {
                        if(elem.calculation_unit_id==elem_cunit.id) {
                          return (
                            <div key={elem_index} className="entity_use_query_popup_result_data_block_results_element">
                              {FormatTooling.defaultsTextFormatTypes(elem.send_at, Constants.crudGenerator.dataTypes.DATETIME) + " - " + elem.email_send + 
                                (elem.error ? " (" + intl.formatMessage({ id: "reportFileAdmin.email.emailErrorMessage"}) + ")": "")}
                            </div>
                          );
                        }
                        return null;
                      })}
                    </div>
                  </div>)
                )}
              </div>
            )}        
          </div>
        </div>
      )}      
    </GlassPopup>
  );
};

export default EmailFinderByCalculationUnitPopup;


// WEBPACK FOOTER //
// ./source/client/components/reportFileAdmin/emailFinderByCalculationUnitPopup.jsx